import { useEffect, useState } from 'react';
const checkDidomiConsent = () => {
    const consentStatus = window?.Didomi?.getCurrentUserStatus?.();
    if (!consentStatus?.purposes) {
        return false;
    }
    const { purposes } = consentStatus;
    return Object.values(purposes).every((purpose) => purpose.enabled);
};
const checkUserCentricsConsent = () => !!window?.UC_UI?.areAllConsentsAccepted();
const checkUserCentricsExists = () => !!window?.UC_UI;
const checkConsent = () => {
    if (checkUserCentricsExists())
        return checkUserCentricsConsent();
    return checkDidomiConsent();
};
export const useConsent = () => {
    const [consent, setConsent] = useState(false);
    let userConsentInterval;
    useEffect(() => {
        userConsentInterval = setInterval(() => {
            if (checkConsent()) {
                clearInterval(userConsentInterval);
                setConsent(true);
            }
        }, 100);
        return () => {
            if (userConsentInterval)
                clearInterval(userConsentInterval);
        };
    }, []);
    return consent;
};
